// Keep a real href and native modified-click/download behavior. Link's router
// transition also passes through the existing record navigation guards.
import { useContext } from "react";
import { Link, UNSAFE_LocationContext, UNSAFE_NavigationContext } from "react-router-dom";
import { recordSwapState } from "../services/recordReturn.js";

export function InternalLink({ href, state, returnRecord, children, ...props }) {
  const router = useContext(UNSAFE_NavigationContext);
  const location = useContext(UNSAFE_LocationContext);
  // Standalone component previews have no application router.
  if (!router || !location || props.download != null) return <a href={href} {...props}>{children}</a>;
  const from = returnRecord && { ...returnRecord, path: location.location.pathname + location.location.search };
  return <Link to={href} state={from ? recordSwapState(from) : state} {...props}>{children}</Link>;
}
